/**
 * Created by dongjf on 2019/5/28
 */
import React, { Component } from 'react';
import { Tabs } from 'antd';
import { getState } from '@@/store';
// 可以传各种 props 设定行为，比如返回空还是 clone 传属性
class AuthorizedTab extends Component {
    dealTab() {
        const resources = getState().global.resources || [];
        const children = this.props.children.slice(0);
        const allow = this.props.allow || [];
        allow.forEach((v, i) => {
            // @ts-ignore
            if (!resources.includes(v)) {
                children[i] = null;
            }
        });
        return children.filter((a) => (a !== null));
    }
    render() {
        const props = this.props;
        const children = this.dealTab();
        if (children.length > 0) {
            const tabProps = {};
            Object.keys(props).forEach((v) => {
                if (v !== 'children' || v !== 'allow') {
                    tabProps[v] = props[v];
                }
                if (v === 'activeKey') {
                    tabProps[v] = props[v] || children[0].key;
                }
            });
            return (<Tabs {...tabProps}>
          {children}
        </Tabs>);
        }
        return null;
    }
}
export default AuthorizedTab;
